export default __webpack_public_path__ + "static/media/logo.7e981a04.svg";